import { NgModule } from '@angular/core';
import { EffectsModule } from '@ngrx/effects';
import { StoreModule } from '@ngrx/store';
import { baseRelatedPspBranchesEffects, baseRelatedPspBranchReducer } from '../../_store';

@NgModule({
  imports: [
    StoreModule.forFeature('relatedPspBranches', baseRelatedPspBranchReducer.BaseRelatedPspBranchesReducer),
    EffectsModule.forFeature([baseRelatedPspBranchesEffects.BaseRelatedPspBranchesEffects]),
  ],
})
export class BaseRelatedPspBranchesStoreModule {}
